// import { TextField, MenuItem, FormControl, InputLabel, Select } from "@mui/material";
// import { PostGeneralInformationFinepAPI, PutGeneralInformationFinepAPI } from "../../../../API/GeneralInformationFinepAPI";
// import { useContext, useEffect, useState } from "react";
// import { GeneralInformationFinepModel } from "../../../../Models/GeneralInformationFINEPModel";
// import { convertCurrencyToFloat } from "../../../../Utils/convertCurrencyToFloat";
// import { toast } from "react-toastify";
// import { IResponseProps } from "../../../../Interfaces/IResponseProps";
// import { UseFormReturn } from "react-hook-form";
// import { CurrencyInput } from "../../../../Components/Shared/CurrencyInput";
// import TabsHeader from "../../../../Components/Shared/TabsHeader";
// import useLoading from "../../../../Hooks/useLoading";
// import Loader from "../../../../Components/Shared/Loader";
// import './styles.css';
// import { TechnologicalFeaturesFinepContext } from "../../../../Contexts/TechnologicalFeaturesFinepContext";

// interface IGeneralInfosTabProps {
//     generalInformationForm: UseFormReturn<GeneralInformationFinepModel, any>,
//     getFilledFirstTabCount: (dataResp: GeneralInformationFinepModel) => number,
//     calculatePercentage: (isValidated: boolean, tabName: string, qtdFilled: number) => void,
//     setCanValidateFirstTab: React.Dispatch<React.SetStateAction<boolean>>,
//     canValidateFirstTab: boolean,
// }

// const GeneralInfosTab = (props: IGeneralInfosTabProps) => {
//     const { watch, register, handleSubmit, setValue, getValues, formState } = props.generalInformationForm;
//     const { isDirty, dirtyFields } = formState;
//     const { loading, toggleLoading } = useLoading();
//     const [totalValue, setTotalValue] = useState<number>(0);
//     const [hasValidated, setHasValidated] = useState<boolean>(false);
//     const generalInformationFields = 4;

//     const watchIsValid = watch("isValid");
//     const watchingValues = watch();
//     const { handleFillTab } = useContext(TechnologicalFeaturesFinepContext);

//     const PostGeneralInformationFinep = async (data: GeneralInformationFinepModel) => {
//         try {
//             toggleLoading(true);

//             await PostGeneralInformationFinepAPI(data).then((resp: IResponseProps) => {
//                 if (resp.statusCode == 200) {
//                     var dataResp = resp.data;

//                     var filled = props.getFilledFirstTabCount(dataResp);

//                     (filled == generalInformationFields)
//                         ? props.setCanValidateFirstTab(true)
//                         : props.setCanValidateFirstTab(false);

//                     setValue('id', dataResp.id);

//                     handleFillTab(0);
//                     props.calculatePercentage(props.canValidateFirstTab, 'generalInformation', filled);
//                 }
//             });
//         } catch (error: any) {
//             toast.error(error);
//         } finally {
//             toggleLoading(false);
//         }
//     }

//     const PutGeneralInformationFinep = async (data: GeneralInformationFinepModel) => {
//         try {
//             toggleLoading(true);

//             await PutGeneralInformationFinepAPI(data).then((resp: IResponseProps) => {
//                 if (resp.statusCode == 200) {
//                     var dataResp = resp.data;

//                     var filled = props.getFilledFirstTabCount(dataResp);

//                     (filled == generalInformationFields)
//                         ? props.setCanValidateFirstTab(true)
//                         : props.setCanValidateFirstTab(false);

//                     handleFillTab(0);
//                     props.calculatePercentage(props.canValidateFirstTab, 'generalInformation', filled);
//                 }
//             });
//         } catch (error: any) {
//             toast.error(error);
//         } finally {
//             toggleLoading(false);
//         }
//     }

//     const EditCurrencyFields = (data: GeneralInformationFinepModel) => {
//         if (dirtyFields.valueImportsAnnual) {
//             let value = 0;
//             if (data.valueImportsAnnual.toString().includes("R$")) {
//                 value = convertCurrencyToFloat(data.valueImportsAnnual.toString());
//             } else {
//                 value = parseFloat(data.valueImportsAnnual.toString())
//             }
//             data.valueImportsAnnual = value;
//             setValue('valueImportsAnnual', value);
//         }
//         if (dirtyFields.averageRemunerationAnual) {
//             let value = 0;
//             if (data.averageRemunerationAnual.toString().includes("R$")) {
//                 value = convertCurrencyToFloat(data.averageRemunerationAnual.toString());
//             } else {
//                 value = parseFloat(data.averageRemunerationAnual.toString())
//             }
//             data.averageRemunerationAnual = value;
//             setValue('averageRemunerationAnual', value);
//         }

//         let value1 = JSON.parse(data.isPossibility.toString());
//         data.isPossibility = value1;
//         setValue('isPossibility', value1);

//         return data;
//     }

//     const submitRegistrationDocumentsForm = (data: GeneralInformationFinepModel) => {
//         var dataEdited = EditCurrencyFields(data);

//         dataEdited.isValid = hasValidated;
//         setValue('isValid', hasValidated);

//         if (isDirty || dataEdited.isValid != data.isValid) {
//             if (data.id != "") {
//                 PutGeneralInformationFinep(dataEdited);
//             } else {
//                 PostGeneralInformationFinep(dataEdited);
//             }
//         }
//     };

//     const getTotalValue = () => {
//         var qtdDoctors = getValues('quantityDoctors')?.toString();
//         var qtdGraduates = getValues('quantityGraduates')?.toString();
//         var qtdMasters = getValues('quantityMasters')?.toString();
//         var qtdMediumFundamental = getValues('quantityMediumFundamental')?.toString();

//         var total = (qtdDoctors != undefined ? parseInt(qtdDoctors) : 0) +
//             (qtdGraduates != undefined ? parseInt(qtdGraduates) : 0) +
//             (qtdMasters != undefined ? parseInt(qtdMasters) : 0) +
//             (qtdMediumFundamental != undefined ? parseInt(qtdMediumFundamental) : 0);

//         setTotalValue(total);
//     }

//     const updateHasValidated = () => {
//         setHasValidated(props.canValidateFirstTab == true ? JSON.parse(getValues("isValid").toString()) : false);
//     }

//     useEffect(() => {
//         getTotalValue();
//     }, [watchingValues]);

//     useEffect(() => {
//         if (hasValidated.toString() != getValues("isValid").toString()) {
//             submitRegistrationDocumentsForm(getValues());
//         }
//     }, [hasValidated]);

//     useEffect(() => {
//         updateHasValidated();
//     }, [watchIsValid, props.canValidateFirstTab]);

//     return (
//         <form onSubmit={handleSubmit(submitRegistrationDocumentsForm)}>
//             {loading && <Loader />}
//             <div className="p-4">
//                 <TabsHeader
//                     canValidate={props.canValidateFirstTab}
//                     setValueSelected={setHasValidated}
//                     valueSelected={hasValidated}
//                     registerId={getValues("registerId")}
//                     cardName=""
//                     tabName=""
//                 />

//                 <h4 className="mt-4 mb-4">
//                     <strong className="color-blue">Pessoal Ocupado</strong>
//                 </h4>

//                 <div className="d-flex align-items-center mb-4">
//                     <strong className="me-4 blue mt-4">
//                         Quantidade
//                     </strong>
//                     <div className="w-100 me-2 ms-4 d-flex flex-column align-items-center">
//                         <InputLabel className="mb-2 font-weight-bold">Doutores</InputLabel>
//                         <TextField
//                             type="number"
//                             className="w-100"
//                             disabled={hasValidated}
//                             {...register('quantityDoctors', { onBlur: handleSubmit(submitRegistrationDocumentsForm) })}
//                         />
//                     </div>
//                     <div className="w-100 me-2 d-flex flex-column align-items-center">
//                         <InputLabel className="mb-2 font-weight-bold">Mestres</InputLabel>
//                         <TextField
//                             type="number"
//                             className="w-100"
//                             disabled={hasValidated}
//                             {...register('quantityMasters', { onBlur: handleSubmit(submitRegistrationDocumentsForm) })}
//                         />
//                     </div>
//                     <div className="w-100 me-2 d-flex flex-column align-items-center">
//                         <InputLabel className="mb-2 font-weight-bold">Graduados</InputLabel>
//                         <TextField
//                             type="number"
//                             className="w-100"
//                             disabled={hasValidated}
//                             {...register('quantityGraduates', { onBlur: handleSubmit(submitRegistrationDocumentsForm) })}
//                         />
//                     </div>
//                     <div className="w-100 me-2 d-flex flex-column align-items-center">
//                         <InputLabel className="mb-2 font-weight-bold">Médio/Fundamental</InputLabel>
//                         <TextField
//                             type="number"
//                             className="w-100"
//                             disabled={hasValidated}
//                             {...register('quantityMediumFundamental', { onBlur: handleSubmit(submitRegistrationDocumentsForm) })}
//                         />
//                     </div>
//                     <div className="w-100 d-flex flex-column align-items-center">
//                         <InputLabel className="mb-2 blue font-weight-bold">Total de Pessoas</InputLabel>
//                         <TextField
//                             type="number"
//                             className="w-100"
//                             disabled
//                             value={totalValue}
//                         />
//                     </div>
//                 </div>

//                 <div className="d-flex align-items-center mt-4 mb-4 w-50 pe-4">
//                     <strong className="me-3">Qual a média de remuneração anual total, em R$, paga no ultimo ano?</strong>
//                     <TextField
//                         label="R$"
//                         {...register('averageRemunerationAnual', { onBlur: handleSubmit(submitRegistrationDocumentsForm) })}
//                         className='w-25'
//                         disabled={hasValidated}
//                         value={getValues('averageRemunerationAnual').toString().replace(".", ",")}
//                         InputProps={{
//                             inputComponent: CurrencyInput as any,
//                         }}
//                         variant="outlined"
//                     />
//                 </div>

//                 <div className="d-flex align-items-start h-100 mt-4">
//                     <div className="w-100 me-2">
//                         <h4>
//                             <strong className="color-blue">
//                                 Plantas de Produção
//                             </strong>
//                         </h4>
//                         <div className="d-flex align-items-center mt-2">
//                             <strong className="me-2 text-nowrap">A empresa possui planta(s) de produção?</strong>
//                             <FormControl className="ms-2">
//                                 <InputLabel id="label-select-prod">Selecione</InputLabel>
//                                 <Select
//                                     placeholder="Selecione"
//                                     labelId="label-select-prod"
//                                     disabled={hasValidated}
//                                     {...register('isPossibility', { onBlur: handleSubmit(submitRegistrationDocumentsForm) })}
//                                     label="Selecione"
//                                     value={getValues('isPossibility').toString()}
//                                 >
//                                     <MenuItem value="false">Não</MenuItem>
//                                     <MenuItem value="true">Sim</MenuItem>
//                                 </Select>
//                             </FormControl>
//                         </div>

//                         {String(getValues('isPossibility')) == "true" &&
//                             <TextField
//                                 id="form-select"
//                                 disabled={hasValidated}
//                                 className="w-100 mt-4"
//                                 label="Municípios onde há produção"
//                                 {...register('townWhereProd', { onBlur: handleSubmit(submitRegistrationDocumentsForm) })}
//                             />
//                         }

//                     </div>
//                     <div className="w-100 d-flex flex-column ms-2 h-100">
//                         <h4>
//                             <strong className="color-blue">
//                                 Outras Informações
//                             </strong>
//                         </h4>
//                         <div className="d-flex align-items-end">
//                             <TextField
//                                 className="w-100"
//                                 disabled={hasValidated}
//                                 label="Qual o valor das importações, em R$, no último ano?"
//                                 {...register('valueImportsAnnual', { onBlur: handleSubmit(submitRegistrationDocumentsForm) })}
//                                 value={getValues('valueImportsAnnual').toString().replace(".", ",")}
//                                 InputProps={{
//                                     inputComponent: CurrencyInput as any,
//                                 }}
//                                 variant="outlined"
//                             />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </form>
//     );
// }

// export default GeneralInfosTab;





import { Input, Form, Select, Typography, Row, Col, Card, InputNumber } from "antd";
import { PostGeneralInformationFinepAPI, PutGeneralInformationFinepAPI } from "../../../../API/GeneralInformationFinepAPI";
import { useContext, useEffect, useState } from "react";
import { GeneralInformationFinepModel } from "../../../../Models/GeneralInformationFINEPModel";
import { convertCurrencyToFloat } from "../../../../Utils/convertCurrencyToFloat";
import { toast } from "react-toastify";
import { IResponseProps } from "../../../../Interfaces/IResponseProps";
import { UseFormReturn } from "react-hook-form";
import { CurrencyInput } from "../../../../Components/Shared/CurrencyInput";
import TabsHeader from "../../../../Components/Shared/TabsHeader";
import useLoading from "../../../../Hooks/useLoading";
import Loader from "../../../../Components/Shared/Loader";
import './styles.css';
import { TechnologicalFeaturesFinepContext } from "../../../../Contexts/TechnologicalFeaturesFinepContext";

const { Text, Title } = Typography;
const { Option } = Select;

const formatCurrency = (value: number | string): string => {
    if (typeof value === 'string') {
        value = parseFloat(value) || 0;
    }
    return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
    });
};
interface IGeneralInfosTabProps {
    generalInformationForm: UseFormReturn<GeneralInformationFinepModel, any>,
    getFilledFirstTabCount: (dataResp: GeneralInformationFinepModel) => number,
    calculatePercentage: (isValidated: boolean, tabName: string, qtdFilled: number) => void,
    setCanValidateFirstTab: React.Dispatch<React.SetStateAction<boolean>>,
    canValidateFirstTab: boolean,
}

const GeneralInfosTab = (props: IGeneralInfosTabProps) => {
    const { watch, register, handleSubmit, setValue, getValues, formState } = props.generalInformationForm;
    const { isDirty, dirtyFields } = formState;
    const { loading, toggleLoading } = useLoading();
    const [totalValue, setTotalValue] = useState<number>(0);
    const [hasValidated, setHasValidated] = useState<boolean>(false);
    const generalInformationFields = 4;
    const watchIsValid = watch("isValid");
    const watchingValues = watch();
    const { handleFillTab } = useContext(TechnologicalFeaturesFinepContext);
    const handleNumberChange = (field: keyof GeneralInformationFinepModel) => (value: number | null) => {
        setValue(field, value ?? 0);
    };

    const handleTextChange = (field: keyof GeneralInformationFinepModel) => (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(field, e.target.value);
    };

    const handleBooleanChange = (field: keyof GeneralInformationFinepModel) => (value: "true" | "false") => {
        setValue(field, value === "true");
    };

    const PostGeneralInformationFinep = async (data: GeneralInformationFinepModel) => {
        try {
            toggleLoading(true);
            await PostGeneralInformationFinepAPI(data).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    var dataResp = resp.data;
                    var filled = props.getFilledFirstTabCount(dataResp);
                    (filled == generalInformationFields)
                        ? props.setCanValidateFirstTab(true)
                        : props.setCanValidateFirstTab(false);
                    setValue('id', dataResp.id);
                    handleFillTab(0);
                    props.calculatePercentage(props.canValidateFirstTab, 'generalInformation', filled);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const PutGeneralInformationFinep = async (data: GeneralInformationFinepModel) => {
        try {
            toggleLoading(true);
            await PutGeneralInformationFinepAPI(data).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    var dataResp = resp.data;
                    var filled = props.getFilledFirstTabCount(dataResp);
                    (filled == generalInformationFields)
                        ? props.setCanValidateFirstTab(true)
                        : props.setCanValidateFirstTab(false);
                    handleFillTab(0);
                    props.calculatePercentage(props.canValidateFirstTab, 'generalInformation', filled);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const EditCurrencyFields = (data: GeneralInformationFinepModel) => {
        if (dirtyFields.valueImportsAnnual) {
            let value = 0;
            if (data.valueImportsAnnual.toString().includes("R$")) {
                value = convertCurrencyToFloat(data.valueImportsAnnual.toString());
            } else {
                value = parseFloat(data.valueImportsAnnual.toString())
            }
            data.valueImportsAnnual = value;
            setValue('valueImportsAnnual', value);
        }

        if (dirtyFields.averageRemunerationAnual) {
            let value = 0;
            if (data.averageRemunerationAnual.toString().includes("R$")) {
                value = convertCurrencyToFloat(data.averageRemunerationAnual.toString());
            } else {
                value = parseFloat(data.averageRemunerationAnual.toString())
            }
            data.averageRemunerationAnual = value;
            setValue('averageRemunerationAnual', value);
        }

        let value1 = JSON.parse(data.isPossibility.toString());
        data.isPossibility = value1;
        setValue('isPossibility', value1);
        return data;
    }

    const submitRegistrationDocumentsForm = (data: GeneralInformationFinepModel) => {
        var dataEdited = EditCurrencyFields(data);
        dataEdited.isValid = hasValidated;
        setValue('isValid', hasValidated);
        if (isDirty || dataEdited.isValid != data.isValid) {
            if (data.id != "") {
                PutGeneralInformationFinep(dataEdited);
            } else {
                PostGeneralInformationFinep(dataEdited);
            }
        }
    };

    const getTotalValue = () => {
        var qtdDoctors = getValues('quantityDoctors') ?? 0;
        var qtdGraduates = getValues('quantityGraduates') ?? 0;
        var qtdMasters = getValues('quantityMasters') ?? 0;
        var qtdMediumFundamental = getValues('quantityMediumFundamental') ?? 0;
        var total = Number(qtdDoctors) + Number(qtdGraduates) + Number(qtdMasters) + Number(qtdMediumFundamental);
        setTotalValue(total);
    }

    const updateHasValidated = () => {
        setHasValidated(props.canValidateFirstTab == true ? JSON.parse(getValues("isValid").toString()) : false);
    }

    useEffect(() => {
        getTotalValue();
    }, [watchingValues]);

    useEffect(() => {
        if (hasValidated.toString() != getValues("isValid").toString()) {
            submitRegistrationDocumentsForm(getValues());
        }
    }, [hasValidated]);

    useEffect(() => {
        updateHasValidated();
    }, [watchIsValid, props.canValidateFirstTab]);

    return (
        <Form onFinish={handleSubmit(submitRegistrationDocumentsForm)}>
            {loading && <Loader />}
            <div className="p-4">
                <TabsHeader
                    canValidate={props.canValidateFirstTab}
                    setValueSelected={setHasValidated}
                    valueSelected={hasValidated}
                    registerId={getValues("registerId")}
                    cardName=""
                    tabName=""
                />
                <Title level={4} style={{ color: '#000085', fontSize: '22px', fontWeight: 'normal' }}>Pessoal Ocupado</Title>
                <div className="d-flex align-items-center mb-4">
                    <strong className="me-4 blue mt-4">
                        Quantidade
                    </strong>
                    <div className="w-50 me-2 ms-2 d-flex flex-column align-items-center">
                        <span className="mb-2 font-weight-normal">Doutores</span>
                        <InputNumber
                            className="w-100"
                            disabled={hasValidated}
                            value={Number(getValues('quantityDoctors')) || 0}
                            onChange={handleNumberChange('quantityDoctors')}
                            onBlur={handleSubmit(submitRegistrationDocumentsForm)}
                            min={0}
                            max={10000}
                        />
                    </div>
                    <div className="w-50 me-2 ms-2 d-flex flex-column align-items-center">
                        <span className="mb-2 font-weight-nomal">Mestres</span>
                        <InputNumber
                            className="w-100"
                            disabled={hasValidated}
                            value={Number(getValues('quantityMasters')) || 0}
                            onChange={handleNumberChange('quantityMasters')}
                            onBlur={handleSubmit(submitRegistrationDocumentsForm)}
                            min={0}
                            max={10000}
                        />
                    </div>
                    <div className="w-50 me-2 ms-2 d-flex flex-column align-items-center">
                        <span className="mb-2 font-weight-normal">Graduados</span>
                        <InputNumber
                            className="w-100"
                            disabled={hasValidated}
                            value={Number(getValues('quantityGraduates')) || 0}
                            onChange={handleNumberChange('quantityGraduates')}
                            onBlur={handleSubmit(submitRegistrationDocumentsForm)}
                            min={0}
                            max={10000}
                        />
                    </div>
                    <div className="w-50 me-2 ms-2 d-flex flex-column align-items-center">
                        <span className="mb-2 font-weight-normal">Médio/Fundamental</span>
                        <InputNumber
                            className="w-100"
                            disabled={hasValidated}
                            value={Number(getValues('quantityMediumFundamental')) || 0}
                            onChange={handleNumberChange('quantityMediumFundamental')}
                            onBlur={handleSubmit(submitRegistrationDocumentsForm)}
                            min={0}
                            max={10000}
                        />
                    </div>
                    <div className="w-50 me-2 ms-2 d-flex flex-column align-items-center">
                        <span className="mb-2 font-weight-normal">Total de Pessoas</span>
                        <InputNumber
                            className="w-100"
                            disabled
                            value={totalValue}
                        />
                    </div>
                </div>
                <Form.Item
                    label="Qual a média de remuneração anual total, em R$, paga no ultimo ano?"
                    labelCol={{ span: 24 }}
                    className="mt-4 mb-4"
                >
                    <Input
                        disabled={hasValidated}
                        value={formatCurrency(getValues('averageRemunerationAnual'))}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '');
                            setValue('averageRemunerationAnual', Number(value) || 0);
                        }}
                        onBlur={handleSubmit(submitRegistrationDocumentsForm)}
                    />
                </Form.Item>

                <div className="mt-4 mb-4">
                    <Title level={4}>
                        <Text strong className="color-blue">Plantas de Produção</Text>
                    </Title>
                    <div className="d-flex align-items-center mt-2">
                        <Text className="me-2 text-nowrap">A empresa possui planta(s) de produção?</Text>
                        <Select
                            placeholder="Selecione"
                            disabled={hasValidated}
                            value={getValues('isPossibility') ? "true" : "false"}
                            onChange={handleBooleanChange('isPossibility')}
                            onBlur={handleSubmit(submitRegistrationDocumentsForm)}
                            style={{ width: 120 }}
                        >
                            <Option value="false">Não</Option>
                            <Option value="true">Sim</Option>
                        </Select>
                    </div>
                    {getValues('isPossibility') && (
                        <Form.Item label="Municípios onde há produção" className="mt-4">
                            <Input
                                disabled={hasValidated}
                                value={getValues('townWhereProd')}
                                onChange={handleTextChange('townWhereProd')}
                                onBlur={handleSubmit(submitRegistrationDocumentsForm)}
                            />
                        </Form.Item>
                    )}
                </div>
                <div className="mt-4">
                    <Title level={4}>
                        <Text strong className="color-blue">Outras Informações</Text>
                    </Title>
                    <Form.Item
                        label="Qual o valor das importações, em R$, no último ano?"
                        labelCol={{ span: 24 }}
                    >
                        <Input
                            disabled={hasValidated}
                            value={formatCurrency(getValues('valueImportsAnnual'))}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '');
                                setValue('valueImportsAnnual', Number(value) || 0);
                            }}
                            onBlur={handleSubmit(submitRegistrationDocumentsForm)}
                        />
                    </Form.Item>
                </div>
            </div>
        </Form>
    );
}
export default GeneralInfosTab;